export default __webpack_public_path__ + "static/Metal_Ladder-4c1f53ff554766244f143ac354ce5eb4.png";